import React from 'react';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import BandWidthChart from '../BandwidthChart';

const BandwidthReportSection = ({ data, networkInData, networkOutData }) => {
  const { t } = useTranslation();

  if (!data?.gatewayNetworkIn && !data?.gatewayNetworkOut) {
    return null;
  }

  return (
    <div>
      <div className="section-title">{t('GATEWAY BANDWIDTH STATISTICS')}</div>
      <Row gutter={8} style={{ marginTop: 10 }}>
        <Col span={12}>
          <div className="content-center chart-item">
            <div className="chart-title">{t('Bandwidth network in')}</div>
            <BandWidthChart
              height={400}
              data={networkInData}
              yLabel="Mbps"
            />
          </div>
        </Col>
        <Col span={12}>
          <div className="content-center chart-item">
            <div className="chart-title">{t('Bandwidth network out')}</div>
            <BandWidthChart
              height={400}
              data={networkOutData}
              yLabel="Mbps"
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default BandwidthReportSection;
